
































































































































































































































































import { Component, Mixins, Prop, PropSync } from 'vue-property-decorator';
import { ClaimOption, ClaimReasonType } from 'supporter';
import claimReasonTypes from '@/const/words/claimReasonTypes';
import AmountMixin from '@/components/claim/popup/mixins/AmountMixin';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {
  isCancelClaim,
  isCancelExchange,
  isCancelNoRefund,
  isCancelProcRequestRefund,
  isCancelRequest,
  isExchangeClaim,
  isExchangeProcBeforeReceive,
  isExchangeRequest,
  isReturnClaim,
  isReturnExchange,
  isReturnProcBeforeReceive,
  isReturnProcRequestReceive,
  isReturnProcRequestRefund,
  isReturnRefundAmtAdjustRequested,
  isReturnRequest,
} from '@/components/claim/popup/validations';
import { ClaimClassType, ClaimStatusType, ClaimType } from '@/types/claim';
import { commaNumStringToNumber } from '@/utils/dataReplaceUtils';

// 클레임 대상 상품 테이블 (A)
@Component({
  components: { CompSelectBox },
  methods: {
    isAnotherPartner(prevPartnerNo: number, currentPartnerNo: number): boolean {
      return prevPartnerNo !== currentPartnerNo;
    },
  },
  computed: {
    isCancelClaim,
    isCancelNoRefund,
    isExchangeClaim,
    isReturnClaim,
    isCancelExchange,
    isReturnExchange,
    isCancelProcRequestRefund,
    isCancelRequest,
    isExchangeRequest,
    isExchangeProcBeforeReceive,
    isReturnRequest,
    isReturnProcRequestRefund,
    isReturnProcRequestReceive,
    isReturnProcBeforeReceive,
    isReturnRefundAmtAdjustRequested,
    isCancelAllClaim() {
      const cancelAllTargetStatus = [
        ClaimStatusType.CANCEL_NO_REFUND,
        ClaimStatusType.CANCEL_REQUEST,
        ClaimStatusType.CANCEL_PROC_REQUEST_REFUND,
        ClaimStatusType.CANCEL_PROC_WAITING_REFUND,
        ClaimStatusType.CANCEL_DONE,
      ];
      const isCancelAllTarget = cancelAllTargetStatus.includes(this.claimStatusType as ClaimStatusType);

      if (
        this.claimStatusType === ClaimStatusType.CANCEL_NO_REFUND ||
        (isCancelAllTarget && this.claimNoResponseData.claimClassType === ClaimClassType.ORDER_CANCEL)
      ) {
        return true;
      }

      return false;
    },
    showModifyButton() {
      return (
        this.isCancelRequest ||
        this.isCancelProcRequestRefund ||
        this.isReturnRequest ||
        this.isReturnProcBeforeReceive ||
        this.isReturnProcRequestRefund ||
        this.isReturnRefundAmtAdjustRequested
      );
    },
  },
})
export default class ClaimProduct extends Mixins(AmountMixin) {
  private claimedOptions: ClaimOption[] = [];
  private claimReasonTypeSelectList = [];
  private partnerRowSpans = {};

  @Prop({ required: true })
  private readonly claimStatusType!: string;
  @PropSync('isModifyMode')
  private isModifyModeSync!: boolean;
  @PropSync('reasonType')
  private reasonTypeSync!: ClaimReasonType;
  @PropSync('reasonDetail')
  private reasonDetailSync!: string;
  @PropSync('responsibleObjectType')
  private responsibleObjectTypeSync!: string;
  @PropSync('refundAdjustAmt')
  private refundAdjustAmtSync!: string;

  created() {
    this.setClaimProductData();
    this.makePartnerRowSpan();
  }

  private setClaimProductData() {
    this.claimedOptions = this.claimNoResponseData.claimedOptions.sort(({ partnerNo: a }, { partnerNo: b }) => Number(a) - Number(b));
    this.claimReasonTypeSelectList = claimReasonTypes;
  }

  private toggleModifyMode() {
    if (!this.validation()) {
      return;
    }
    this.refundAdjustAmtSync = '0';
    this.isModifyModeSync = !this.isModifyModeSync;
  }

  private validation() {
    if (
      this.claimNoResponseData.originalPayType === 'NAVER_PAY' &&
      [ClaimStatusType.CANCEL_REQUEST, ClaimStatusType.RETURN_REQUEST].includes(this.claimStatusType as ClaimStatusType)
    ) {
      alert('네이버페이 주문형 주문은 네이버페이센터를 통해 처리해 주세요.');
      return false;
    }

    if (this.refundAdjustAmtSync && commaNumStringToNumber(this.refundAdjustAmtSync) > 0) {
      if (!confirm(this.$t('CLAIM_POPUP_ASK_ADJUSTMENT_AMOUNT_INITIALIZE').toString())) {
        return false;
      }
    }

    return true;
  }

  private showStockStatus(claimedOption: ClaimOption): string {
    const { restoresStock, claimStatusType } = claimedOption;

    const isReturnClaim =
      this.claimType === ClaimType.RETURN || this.claimNoResponseData.claimClassType === ClaimClassType.RETURN_EXCHANGE;

    const isExceptClaimStatusType = [
      ClaimStatusType.RETURN_REQUEST,
      ClaimStatusType.RETURN_REJECT_REQUEST,
      ClaimStatusType.RETURN_PROC_BEFORE_RECEIVE,
      ClaimStatusType.EXCHANGE_REQUEST,
      ClaimStatusType.EXCHANGE_REJECT_REQUEST,
      ClaimStatusType.EXCHANGE_PROC_BEFORE_RECEIVE,
    ].includes(claimStatusType as ClaimStatusType);

    const isTargetClaimStatusType = [
      ClaimStatusType.RETURN_DONE,
      ClaimStatusType.EXCHANGE_DONE_PAY_DONE,
      ClaimStatusType.EXCHANGE_DONE_REFUND_DONE,
      ClaimStatusType.EXCHANGE_DONE,
    ].includes(claimStatusType as ClaimStatusType);

    if (restoresStock && isReturnClaim && !isExceptClaimStatusType) {
      if (isTargetClaimStatusType) {
        return this.$t('CLAIM_POPUP_RESTORE_STOCK_COMPLETE').toString();
      } else {
        return this.$t('CLAIM_POPUP_RESTORE_STOCK').toString();
      }
    }
  }

  private makePartnerRowSpan() {
    const rowSpans = this.claimedOptions.reduce((acc, current) => {
      if (typeof acc[current.partnerNo] === 'undefined') {
        acc[current.partnerNo] = 1;
      } else {
        acc[current.partnerNo] += 1;
      }

      return acc;
    }, {});

    this.partnerRowSpans = rowSpans;
  }

  private showSetOptionLayerPop = true;
  private productDataPop: any = {
    id: 'setOption',
    width: 800,
    maxHeight: 500,
    title: '세트상품 상세',
    nonFooter: false,
    hasConfirmBtn: false,
    hasCloseBtn: true,
  };

  private mockSetOptions = [
    {
      sku: null,
      count: 1,
      option: 'ss: 200',
      stockNo: 5331762,
      optionName: 'ss',
      optionPrice: 17000,
      optionUseYn: null,
      optionValue: '200',
      productName: 'testchoiceari',
      mallOptionNo: 35798168,
      mallProductNo: 101930786,
      optionManagementCd: 'ff',
      productManagementCd: '',
    },
    {
      sku: null,
      count: 1,
      option: 'ss: 0',
      stockNo: 5331761,
      optionName: 'ss',
      optionPrice: 8000,
      optionUseYn: null,
      optionValue: '0',
      productName: 'testchoiceari',
      mallOptionNo: 35798167,
      mallProductNo: 101930786,
      optionManagementCd: 'ss',
      productManagementCd: '',
    },
  ];
}
